module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labelAnnually":"Annually","labelQuarterly":"Quarterly","labelMonthly":"Monthly"},"de":{"labelAnnually":"Jährlich","labelQuarterly":"Vierteljährlich","labelMonthly":"Monatlich"}}')
  delete Component.options._Ctor
}
